import { createDomain } from "effector"
import { useStore } from "effector-react"
import FilterOffIcon from "remixicon-react/FilterOffFillIcon"

import * as Century from "@/domains/centuries"
import * as Country from "@/domains/countries"
import { IconButton } from "@/ui/button"
import { Stack } from "@/ui/stack"
import { Throbber } from "@/ui/throbber"

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------

type Filters = {
  century?: Century.Century
  country?: Country.Country
}

const domain = createDomain("authorListFilters")

export const setCentury = domain.createEvent<Century.Century | undefined>(
  "setCentury"
)
export const setCountry = domain.createEvent<Country.Country | undefined>(
  "setCountry"
)
export const reset = domain.createEvent<void>()

export const $filters = domain
  .createStore<Filters>({})
  .on(setCentury, (state, century) => ({ ...state, century }))
  .on(setCountry, (state, country) => ({ ...state, country }))
  .reset(reset)

export const $filterCount = $filters.map(
  (filters) => Object.values(filters).filter(Boolean).length
)

// -----------------------------------------------------------------------------
// View
// -----------------------------------------------------------------------------

export function Filters({
  disabled = false,
  loading = false,
}: {
  disabled?: boolean
  loading?: boolean
}) {
  const { country, century } = useStore($filters)
  const filterCount = useStore($filterCount)

  return (
    <Stack gap={4} align="center" css={{ mb: "$4" }}>
      <Country.CountrySelect
        value={country}
        onValueChange={setCountry}
        disabled={disabled}
      />
      <Century.CenturiesSelect
        value={century}
        onValueChange={setCentury}
        disabled={disabled}
      />
      {filterCount > 0 && (
        <IconButton onClick={() => reset()}>
          <FilterOffIcon size="1.25em" />
        </IconButton>
      )}
      {loading && <Throbber />}
    </Stack>
  )
}
